/**
 * @typedef {ReturnType<typeof import('widgets/forms/ajax/LoginForm').default>} LoginForm
 */

/**
 * @param {LoginForm} LoginForm Base widget for extending
 * @returns {typeof CheckoutLoginForm} Checkout Login Form widget
 */
export default function (LoginForm) {
    /**
     * @category widgets
     * @subcategory forms
     * @class CheckoutLoginForm
     * @augments LoginForm
     * @classdesc Checkout login form component with the next features:
     * 1. Upon successful login, replaces the current state in the history object with the cart page.<br>
     * *The aim - user who is logged in should not go back to the login page by clicking the Back button.*
     * @property {string} data-widget - Widget name `checkoutLoginForm`
     * @property {string} data-cart-url - Shopping cart URL
     * @example <caption>Example of checkout login form</caption>
     * <form
     *      action="${pdict.actionUrl}"
     *      method="POST"
     *      data-widget="checkoutLoginForm"
     *      data-event-submit.prevent="handleSubmit"
     *      data-cart-url="${URLUtils.https('Cart-Show')}"
     *      novalidate
     *  >
     *      ... form fields
     *      <button
     *          type="submit"
     *          data-widget="button"
     *          data-widget-event-click="handleSubmit"
     *          data-event-click.prevent="handleClick"
     *          data-id="submitButton"
     *      >${Resource.msg(pdict.loginForm.submit.label, 'forms', null)}</button>
     * </form>
     */
    class CheckoutLoginForm extends LoginForm {
        prefs() {
            return {
                cartUrl: '',
                ...super.prefs()
            };
        }

        /**
         * @description Replace the current state in the history object with the cart page if submission was success
         * @param {object} data Server JSON response once form submitted
         * @param {string} data.success - If form submission was success
         * @returns {void}
         */
        onSubmitted(data) {
            if (data.success) {
                window.history.replaceState(null, '', this.prefs().cartUrl);
            }
            super.onSubmitted(data);
        }
    }

    return CheckoutLoginForm;
}
